var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnmuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#39BBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23C21.66 23 22.99 21.66 22.99 20L23 14C23 12.34 21.66 11 20 11C18.34 11 17 12.34 17 14V20C17 21.66 18.34 23 20 23ZM25.3 20C25.3 23 22.76 25.1 20 25.1C17.24 25.1 14.7 23 14.7 20H13C13 23.42 15.72 26.23 19 26.72V30H21V26.72C24.28 26.24 27 23.42 27 20H25.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnmuted);
export default __webpack_public_path__ + "static/media/icon_unmuted.c9e4fcda35dc8b0fe05e4ea676bee688.svg";
export { ForwardRef as ReactComponent };